export { addToFolderEventAction } from 'next-flight-server-reference-proxy-loader?id=40b2e969d3210b6d58efb7b80e6c749dd23d46de08&name=addToFolderEventAction!'